import { graphql, useStaticQuery } from 'gatsby';

const useMagazineDownloadImages = () => {
  const { allContentfulWebsiteImage } = useStaticQuery(graphql`
    query {
      allContentfulWebsiteImage(
        filter: {
          contentful_id: {
            in: [
              "1o1kte8SEjPWVkIW1GMtjh" #Magazine Download Img
              "5mZ50l2Xhr4LtrAarJQIn5" #Magazine Download Img 1
            ]
          }
        }
      ) {
        edges {
          node {
            ...WebsiteImage
          }
        }
      }
    }
  `);

  return allContentfulWebsiteImage?.edges;
};

export default useMagazineDownloadImages;
